import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ChuyenKho } from "./ChuyenKho";

export const BtnChuyenKho = (TaiSanID) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  const funcionHandleShow = () => {
    setShow(true);
  };

  return (
    <>
      <a onClick={funcionHandleShow} href={() => false}>
        <PopoversBootrap
          contentText="Chuyển kho"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
           <img src="/app-assets/images/icon-chuyen-kho-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ChuyenKho show={show} onHide={handleClose} TaiSanID={TaiSanID} />
      )}
    </>
  );
};
